export default {
  install(Vue) {
    Vue.prototype.__ = () => {};
  },
};
